import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router";
import { ToastContainer } from "react-toastify";
import { suppressApexChartsErrors } from "utils/errorSuppressionUtils";

suppressApexChartsErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastContainer autoClose={2500} />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
